import { IconLock } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

export default function ToolTrustBanner() {
    const { t } = useTranslation();

    return (
        <div className="mt-3 flex items-center gap-2.5 rounded-[14px] border border-[#CBE9D7] bg-[#E3F6EC] px-4 py-3 dark:border-emerald-900/40 dark:bg-emerald-950/20">
            <IconLock size={20} stroke={1.8} className="flex-none text-[#1E9E5E]" />
            <span className="text-[13px] leading-relaxed text-[#3D3833] dark:text-zinc-300">
                {t('toolPage.privacy')}
            </span>
        </div>
    );
}
